import React, { memo } from "react";
import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
  Box,
  Chip,
  Rating,
  IconButton,
} from "@mui/material";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import "./style.css";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { t } from "i18next";

const ProviderCard = ({ data, index, handleClickOnCard }) => {
  const distanceInKm = data?.distance ? (data.distance / 1000).toFixed(2) : 0;

  return (
    <Card
      onClick={() => handleClickOnCard(data, index)}
      sx={{
        borderRadius: 2,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        cursor: "pointer",
      }}
    >
      {data?.backgroundImages ? (
        <Box sx={{ position: "relative" }}>
          <Chip
            label={data.expertise}
            sx={{
              top: 5,
              right: 5,
              height: 25,
              position: "absolute",
              borderRadius: "6px",
              color: "text.white",
              zIndex: 999,
              background: "#7922d8",
            }}
          />
          <Carousel
            showArrows
            infiniteLoop
            showIndicators={false}
            showStatus={false}
            showThumbs={false}
            renderArrowPrev={(clickHandler, hasPrev) => {
              return (
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    padding: "3px",
                    position: "absolute",
                    top: "40%",
                    left: "5px",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": {
                      boxShadow: 2,
                      backgroundColor: "#fff",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    clickHandler(e);
                  }}
                >
                  <KeyboardArrowLeft sx={{ fontSize: "20px" }} />
                </IconButton>
              );
            }}
            renderArrowNext={(clickHandler, hasNext) => {
              return (
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    padding: "3px",
                    position: "absolute",
                    top: "40%",
                    right: "5px",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": {
                      boxShadow: 2,
                      backgroundColor: "#fff",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    clickHandler(e);
                  }}
                >
                  <KeyboardArrowRight sx={{ fontSize: "20px" }} />
                </IconButton>
              );
            }}
          >
            {data?.backgroundImages?.map((imageee) => {
              return (
                <img
                  src={imageee}
                  style={{
                    height: "200px",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
                // <Box
                //   sx={{
                //     height: 250,
                //     width: "100%",
                //     display: "flex",
                //     alignItems: "center",
                //     justifyContent: "center",
                //     background: `url(${imageee})`,
                //     backgroundSize: "cover",
                //     backgroundPosition: "center",
                //     position: "relative",
                //   }}
                // ></Box>
              );
            })}
          </Carousel>

          <Box
            height={70}
            width={70}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            bgcolor={"#ffffff8a"}
            zIndex={1}
            position={"absolute"}
            bottom={"10px"}
            left={"10px"}
            borderRadius={2}
            sx={
              {
                // opacity:0.4
              }
            }
          >
            <Avatar
              src={data?.profileImg}
              sx={{
                height: 55,
                width: 55,
                border: "2px solid white",
              }}
            />
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            height: 200,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #9700e1, #ceaffff5)",
            position: "relative",
          }}
        >
          <Chip
            label={data.expertise}
            sx={{
              top: 5,
              right: 5,
              height: 20,
              position: "absolute",
              borderRadius: "6px",
              color: "text.white",
            }}
          />

          <Avatar
            src={data?.profileImg}
            sx={{
              height: 70,
              width: 70,
              border: "2px solid black",
              zIndex: 1,
              position: "absolute",
              bottom: "10px",
              left: "10px",
            }}
          />
        </Box>
      )}
      <CardActionArea sx={{ paddingTop: 0 }}>
        {/* Card Content */}
        <CardContent
          sx={{
            pt: 1,
          }}
          //  onClick={() => handleClickOnCard(data, index)}
        >
          <Typography variant="h6" fontWeight="500" noWrap>
            {data.name}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {data?.bio || `${t("providerDescription")}.`}
          </Typography>

          <Stack
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Rating
              precision={0.5}
              value={data?.rating || 1}
              readOnly
              size="small"
            />
            {data?.distance > 0 ? (
              // <Chip label={`${(data.distance / 1000).toFixed(2)} km`} variant="filled"/>

              <Typography fontSize={12} fontWeight={800} color="primary.main">
                {(data.distance / 1000).toFixed(2)} km
              </Typography>
            ) : data?.distance && data?.distance === 0 ? (
              <Typography fontSize={12} fontWeight={800} color="primary.main">
                {data.distance} km
              </Typography>
            ) : null}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default memo(ProviderCard);
